var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_data_accessor_interface = function () {
    return {
        get_accumulated_data: function(request) {
            var mngr = OCS.Viewer.Functions.get_data_manager();
            return mngr.get_accumulated_data(request);
        },
        is_data_accumulated: function (request) {
            var mngr = OCS.Viewer.Functions.get_data_manager();
            return mngr.is_data_accumulated(request);
        },
        get_stored_data: function (storage_key) {
            var mngr = OCS.Viewer.Functions.get_data_manager();
            return mngr.get_stored_data(storage_key);
        },
        get_storage_key: function (dataset, gridded, timestamp, vars) {
            var mngr = OCS.Viewer.Functions.get_data_manager();
            return mngr.get_storage_key(dataset, gridded, timestamp, vars);
        }
    };
};
OCS.Viewer.Interfaces.DataAccessor = OCS.Viewer.Functions.define_data_accessor_interface();